module.exports = __webpack_public_path__ + "static/media/navigation-action.efb20889.png";